<div #mapContainer class="w-full h-full relative"></div>